import './ScheduleDialog.css';
import '../Dialog.css'

import React, { Component } from 'react';
import Services from '../../tools/Services';

import Table     from '@material-ui/core/Table';
import TableRow  from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import Divider   from '@material-ui/core/Divider';
import ListItem     from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';

import IconButton   from '@material-ui/core/IconButton';
import { TableContainer }  from '@material-ui/core';

import CloseIcon      from '@material-ui/icons/Close';
import FlightIcon    from '@material-ui/icons/Flight';
import ScheduleIcon  from '@material-ui/icons/Schedule';

export default class ScheduleDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            aircraft: [],
            bookings: [],
            open: false,
            openSchedule: true,
            openAircraft: true,
        };
        this.timer = null;
        this.table = undefined;
        this.map = this.props.map;
        this.loadSchedule = this.loadSchedule.bind(this); // FIXME to remove

    }

    componentDidMount() {
        this.eventListener();
        this.loadSchedule();
    }
    
    async loadSchedule() {

        // Post
        let res = await Services.post('bookings/getDaySchedule', {});

        // Error
        if (res.status === 'error')
            return console.error('ScheduleDialog.loadSchedule: ' + res.error);

        // Success
        // Sort by arrival
        this.setState({ bookings: res.aircraftBookingsForMap});


        // If open start timer
        if (this.state.open)
            return this.startTimer(this.loadSchedule);

        // If not, stop the timer
        clearTimeout(this.timer);
    }
    
    startTimer(func) {
        // Update the schedule every 1 min
        this.timer = setTimeout(func, 60000);
    }
    
    eventListener() {
        window.addEventListener('Schedule', (e) => {
            this.setState({
                aircraft: e.detail
            });
        
        }, false);
    }

    // Schedule Display Function
    getIcon(a) {
        if (a.aircraft_type === "R") return 'mdi mdi-helicopter helo';
        if (a.inflight) return 'mdi mdi-airplane-takeoff inFlight';
        return 'mdi mdi-airplane-landing';
    }
    
    getFont(inflight) {
        if (inflight)
        return "inflight";
    }
    
    getColor(inflight) {
        if (inflight) {
            return "#4285F4";
        }
    }
    
    getIconTitle(inflight) {
        
        // Display the text to understand the icon
        if (inflight)
            return 'In flight'; // TODO SR
            return 'Landed'; // TODO SR
    }
        
    getRowClass(inflight) {
        if (inflight)
        return 'inflightRow';
        return '';
    }
    
    // Handles
    openTab = (e) => {
        let property = e.currentTarget.name;
        this.setState({
            [property]: !this.state[property]
        })
    }
    
    handleScheduleClick = (a) => {

        // Send event on aircraft click with currently clicked maker
        let ev = new CustomEvent('aircraftClick', {
            detail: a
        });

        window.dispatchEvent(ev);

        let evnt = new CustomEvent('aircraft', {
            detail: a
        });

        window.dispatchEvent(evnt);
    }

    getCompanyOrUserName() {
       
        // This is a company
        if (Services.isCompany()) {
            let company = Services.getCompany();
            return company.name;
        }

        // this is a user
        let user = Services.getUser();
        if (user === null)
            return '';
        
		return `${user.firstname} ${user.lastname}`;
	}

    render() {
        let { aircraft, bookings} = this.state;
        let { onClose, open, squishContent } = this.props;
        
        let cssId = 'ScheduleDialog';
        let bookingTable = "bookingsTable";
        let bookingHeader = "bookingsTableHeader";
        let bookingsHiddenMain;
        
        let aircraftsTable = "aircraftsTable"
        let aircraftTableHeader = "aircraftsTableHeader";

        // hide dialog if not open
        if (!open) cssId = 'ScheduleDialogClosed';
        
        // hide bookings if no results
        if(bookings.length === 0){
            bookingHeader = "hideBookings";
            bookingTable = "hideBookings";
            bookingsHiddenMain = 'hideBookingsSched'
            aircraftsTable ="aircraftsTableAlt"
            aircraftTableHeader = "aircraftsTableHeaderHidden"
        } 

        return (                
            <div id={cssId} className={bookingsHiddenMain} >
            
            <div className="closeDialog">
                <h5>{this.getCompanyOrUserName()}</h5>
                <IconButton onClick={onClose}>
                    <CloseIcon className="dialogIcon" edge="end" ></CloseIcon>
                </IconButton>
            </div>
                        

            {/* BOOKINGS */}
        
            <div id={bookingHeader}>
                <Divider></Divider>
				<ListItem className="dialogListTitle">
					<ListItemIcon>
						<ScheduleIcon className="dialogIcon" ></ScheduleIcon>
					</ListItemIcon>
					<ListItemText >Schedule</ListItemText>
				</ListItem>
				<Divider></Divider>
            </div>
            <div id={bookingTable}>
				<TableContainer >
					<Table  className={squishContent}> 
						<TableHead>
							<TableRow>
								<TableCell align='left'>Aircraft</TableCell>
								<TableCell align='left'>Departure</TableCell>
								<TableCell align='left'>Arrival</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
						{bookings.map((b, i) => {
								return (
									<TableRow key={i}>
										<TableCell>{b.registration}</TableCell>
										<TableCell align='left'>{Services.dateConverter(b.timestamp_begin, 'hh:mm')}</TableCell>
										<TableCell align='left'>{Services.dateConverter(b.timestamp_end, 'hh:mm')}</TableCell>
									</TableRow>
								)
							})
						}
						
						</TableBody>
					</Table>
				</TableContainer>
            </div>
              
            {/* AIRCRAFT TABLE */}
            <div id={aircraftTableHeader}>
                <Divider></Divider> 
                <ListItem className="dialogListTitle">
                    <ListItemIcon>
						<FlightIcon className="dialogIcon"></FlightIcon>
                    </ListItemIcon>
                    <ListItemText >Aircraft</ListItemText>
                </ListItem>
                <Divider></Divider>
            </div>
            <div id={aircraftsTable}>
                <TableContainer>
                    <Table >
                        <TableHead>
                            <TableRow>
                                <TableCell>Registration</TableCell>
                                <TableCell className='model'>Model</TableCell>
                                {/* <TableCell>Status</TableCell> */}
                            </TableRow>
                        </TableHead>
                        <TableBody >
                            {aircraft.map((a, i) => {

                                return (
                                    <TableRow hover className={this.getRowClass(a.inflight)} key={i} onClick={() => this.handleScheduleClick(a)}>
                                        <TableCell className={this.getFont(a.inflight)}>{a.registration}</TableCell>
                                        <TableCell className={this.getFont(a.inflight)}>{`${a.mfr} ${a.model}`}</TableCell>
                                        {/* <TableCell className={this.getFont(a.inflight)} title={this.getIconTitle(a.inflight)} ><span className={this.getIcon(a)}></span></TableCell> */}
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </div>
    )}
}